/* ============================================================
   Dathent — connectable social platforms (shared)
   Single source of truth for "which platforms can a user connect, in what
   order" — was a local const in screens/Settings.jsx (its own connect
   grid); the dashboard's FinishSetupCard (variant A setup card, owner
   decision 2026-09-09) needs the same list for its row-1 platform icon
   chips, so it moved here rather than being duplicated.
   ============================================================ */
export const CONNECTABLE_PLATFORMS = [
  { id: 'instagram', name: 'Instagram' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'linkedin', name: 'LinkedIn' },
  { id: 'x', name: 'X' },
  // TikTok ungated 2026-07-20 with the composer tile: the OAuth connect flow
  // is live (auth-worker tiktok-oauth) and image posts publish as drafts to
  // the user's TikTok inbox (prod TIKTOK_PUBLISH_ENABLED=1). Only
  // direct-post-with-music stays behind the pending Content-Posting audit.
  { id: 'tiktok', name: 'TikTok' },
  { id: 'threads', name: 'Threads' },
  { id: 'telegram', name: 'Telegram' },
];

// Brand-correct display names for every platform key the app can render,
// not only the connectable ones: `twitter` is the legacy alias of `x`,
// `youtube` comes from PostPreview/Library name normalisation, `bluesky`
// from the composer's per-platform limits.
const PLATFORM_DISPLAY_NAMES = new Map([
  ...CONNECTABLE_PLATFORMS.map((p) => [p.id, p.name]),
  ['twitter', 'X'],
  ['youtube', 'YouTube'],
  ['bluesky', 'Bluesky'],
]);

// Direct content items (including Preview drafts) have no batch/platform
// column. Their saved version is authoritative; metadata is never a platform.
export function platformFromVersions(versions) {
  if (!versions || typeof versions !== 'object' || Array.isArray(versions)) return null;
  const key = Object.keys(versions).find((name) => PLATFORM_DISPLAY_NAMES.has(name.toLowerCase()));
  return key ? (key.toLowerCase() === 'twitter' ? 'x' : key.toLowerCase()) : null;
}

// The one helper for turning a raw platform key ("tiktok", "LINKEDIN")
// into its user-facing label ("TikTok", "LinkedIn"). Never capitalise a
// key by hand (charAt(0).toUpperCase() or CSS text-transform) — that is
// how "Tiktok" and "Linkedin" reached the UI. Lookup is case-insensitive;
// an unknown value keeps its own casing with the first letter capitalised
// (free-text values such as "YouTube Shorts" pass through intact); a
// missing value returns ''.
export function platformDisplayName(platform) {
  const value = String(platform || '').trim();
  if (!value) return '';
  return PLATFORM_DISPLAY_NAMES.get(value.toLowerCase()) || value.charAt(0).toUpperCase() + value.slice(1);
}
